import { useState } from 'react';
import { Mail, X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const C = {
  accent: '#D97757',
  accentS: 'rgba(217,119,87,0.13)',
  accentB: 'rgba(217,119,87,0.32)',
  text: '#F0EDE8',
  muted: '#888',
  green: '#4CAF82',
};

export default function VerifyEmailBanner({ user }) {
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  if (!user || user.email_verified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    setError('');
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/resend-verification`, {
        method: 'POST',
        credentials: 'include',
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || 'Could not send email');
      setSent(true);
      setTimeout(() => setSent(false), 6000);
    } catch (err) {
      setError(err.message);
      setTimeout(() => setError(''), 6000);
    }
    setSending(false);
  };

  return (
    <div
      data-testid="verify-email-banner"
      style={{
        background: C.accentS,
        borderBottom: `0.5px solid ${C.accentB}`,
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 14,
        fontSize: 13.5,
        color: C.text,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
        <Mail size={15} color={C.accent} strokeWidth={2} style={{ flexShrink: 0 }} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {sent ? (
            <span style={{ color: C.green }}>
              ✓ Verification email sent to <strong>{user.email}</strong>. Check your inbox.
            </span>
          ) : error ? (
            <span style={{ color: '#FF7070' }}>{error}</span>
          ) : (
            <>
              Please verify your email <strong>{user.email}</strong> to unlock all features.
            </>
          )}
        </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        {!sent && !error && (
          <button
            onClick={handleResend}
            disabled={sending}
            data-testid="resend-verification-btn"
            style={{
              background: 'transparent',
              border: `0.5px solid ${C.accentB}`,
              color: C.accent,
              padding: '5px 12px',
              borderRadius: 6,
              fontSize: 12.5,
              fontWeight: 500,
              cursor: sending ? 'wait' : 'pointer',
              opacity: sending ? 0.7 : 1,
            }}
          >
            {sending ? 'Sending...' : 'Resend email'}
          </button>
        )}
        <button
          onClick={() => setDismissed(true)}
          title="Dismiss"
          data-testid="dismiss-verify-banner"
          style={{ background: 'transparent', border: 'none', color: C.muted, cursor: 'pointer', padding: 3, display: 'flex' }}
        >
          <X size={14} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}
